import { useFlash } from 'contexts/flash';
import { useCallback } from 'react';
import { createPreSeizure, generatePreSeizure, renderPayloadSeizure } from 'services/files';
import { useNavigate, useSearchParams } from 'react-router-dom';
import axios from 'axios';
import { FormPostSeizure } from '../../PostSeizurePage/components/modules/FormPostSeizure/FormPostSeizure';
import { useAsyncCallback } from 'hooks/useAsyncCallback';

export const useInjection = () => {
  const { setFlash } = useFlash();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const onCreatePreSeizure = useCallback(
    async (formData: FormPostSeizure) => {
      const formData2 = new FormData();
      let filePhotosIds: number[] = [];
      const filePhotos = formData.fileDocumentAdd;
      if (filePhotos?.length) {
        for (let x = 0; x < filePhotos.length; x++) {
          formData2.append('files', filePhotos[x]!, filePhotos[x]!.name);
        }
        const { data: resListIdFile } = await axios.post(
          '/storages/pre_seizures_document',
          formData2,
          {
            headers: { 'Content-Type': 'multipart/form-data' }
          }
        );
        filePhotosIds = resListIdFile.files;
        formData2.delete('files');
      }

      const payload = renderPayloadSeizure(formData, filePhotosIds);
      const data = await createPreSeizure(payload);
      navigate(`/admin/redemptions/pre-seizure/edit/${data.filePreSeizure.id}`);
      setFlash({ type: 'success', message: 'Create pre seizure successful' });
    },
    [setFlash]
  );

  const { asyncCallback } = useAsyncCallback(onCreatePreSeizure, []);

  const handleGenerate = async (formData: FormPostSeizure) => {
    const formData2 = new FormData();
    let filePhotosIds: number[] = [];
    const filePhotos = formData.fileDocumentAdd;
    if (filePhotos?.length) {
      for (let x = 0; x < filePhotos.length; x++) {
        formData2.append('files', filePhotos[x]!, filePhotos[x]!.name);
      }
      const { data: resListIdFile } = await axios.post(
        '/storages/pre_seizures_document',
        formData2,
        {
          headers: { 'Content-Type': 'multipart/form-data' }
        }
      );
      filePhotosIds = resListIdFile.files;
      formData2.delete('files');
    }

    const payload = renderPayloadSeizure(formData, filePhotosIds);
    const data = await createPreSeizure(payload);
    if (data.filePreSeizure.id) {
      await generatePreSeizure(data.filePreSeizure.id, payload);
      setFlash({ type: 'success', message: 'Generate successful' });
    }
    navigate(`/admin/redemptions/pre-seizure/edit/${data.filePreSeizure.id}`);
  };
  const { asyncCallback: generateSeizure } = useAsyncCallback(handleGenerate, []);

  return {
    searchParams,
    generateSeizure,
    onCreatePreSeizure: asyncCallback,
    handleOnBack: () => navigate(`/admin/redemptions`)
  };
};
